import React from "react"
import { Link, graphql } from "gatsby"
import rehypeReact from "rehype-react"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"

import SvgExample from '../components/svg/svg-example';
import StrokeExample from '../components/svg/stroke-example';
import ArcExample from '../components/curves/arc-example';
import CurveExample from '../components/curves/index';

import SvgPaths from '../components/writings/svg-paths';
import Svg123 from '../components/writings/svg-123';
import NormanDoors from '../components/writings/norman-doors';

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: {
    "svg-example": SvgExample,
    "stroke-example": StrokeExample,
    "arc-example": ArcExample,
    "svg-curve-example": CurveExample
  }
}).Compiler;

const renderIllustration = (type) => {
  switch (type) {
    case 'Getting to know the <path>': {
      return <SvgPaths />;
    }
    case 'How to SVG': {
      return <Svg123 />;
    }
    case 'Frustrating doors': {
      return <NormanDoors />;
    }
  }
}

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article>
          <header>
            {renderIllustration(post.frontmatter.title)}
            <h1
              style={{
                marginTop: rhythm(1),
                marginBottom: rhythm(1 / 4),
              }}
            >
              {post.frontmatter.title}
            </h1>
            <p
              style={{
                ...scale(-1 / 5),
                marginTop: 0,
                marginBottom: rhythm(1),
                fontFamily: 'Consolas, serif',
                color: 'var(--slight)',
                fontWeight: 'bold'
              }}
            >
              {post.frontmatter.date}
            </p>
          </header>
          <section>
            {renderAst(post.htmlAst)}
          </section>
          <footer>
            <Bio />
          </footer>
        </article>

        <nav>
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
              margin: 0,
              marginBottom: rhythm(1),
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      htmlAst
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`
